import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PresentationSheet } from '../../presentation-sheet/models/presentation-sheet';

@Injectable({
  providedIn: 'root',
})
export class PresentationSheetService {
  private readonly sheetQuery = `${environment.api}/scheda-presentazione-query/scheda-presentazione`;
  private readonly sheetCommand = `${environment.api}/scheda-presentazione-command/scheda-presentazione`;
  constructor(private http: HttpClient) {}

  getByPraticaId(idPratica: string) {
    let params = new HttpParams()
      .set('populateBilancio', false)
      .set('populateEsposizione', false);
    return this.http.get<PresentationSheet>(
      `${this.sheetQuery}/pratica/${idPratica}`,
      { params: params }
    );
  }

  getByPraticaAndPG(idPratica: string, idPersonaGiuridica: string) {
    let params = new HttpParams()
      .set('populateBilancio', false)
      .set('populateEsposizione', false);
    return this.http.get<PresentationSheet>(
      `${this.sheetQuery}/pratica-persona-giuridica/${idPratica}/${idPersonaGiuridica}`,
      { params: params }
    );
  }

  edit(body: Partial<PresentationSheet>, id: string) {
    return this.http.put(`${this.sheetCommand}/${id}`, body);
  }
}
